import { RestResponse } from "@/business/shared/commons/rest/RestResponse";
import { restClient } from "@/business/shared/commons/rest/restClient";
import { deleteEventUrl } from "../constants/urls";
import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { DaccachErrorActions } from "@/business/shared/commons/DaccachError";

export const deleteEventService = {
  async execute(token: string): Promise<void> {
    const url = getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(deleteEventUrl);

    const headers = {
      "web-token": token,
      Accept: "application/json",
    };

    const response: RestResponse = await restClient().sendRequest(
      url,
      "DELETE",
      null,
      headers
    );

    if (!response.isSuccess) {
      const errorMessage =
        response.statusCode == 422
          ? DaccachErrorActions().extractFormError(response.content)
          : response.content;
      throw DaccachErrorActions().createError(errorMessage);
    }
  },
};
